import PropTypes from 'prop-types';
import { associationTypes } from '../associations/types';

export const AssociationShape = PropTypes.shape({
  originItemId: PropTypes.string.isRequired,
  destinationItemId: PropTypes.string.isRequired,
  associationType: PropTypes.oneOf(Object.keys(associationTypes)),
  id: PropTypes.string.isRequired,
});

export const DocumentItemShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  documentId: PropTypes.string.isRequired,
  fullStatement: PropTypes.string,
  humanCodingScheme: PropTypes.string,
  abbreviatedStatement: PropTypes.string,
  createdAt: PropTypes.string,
  modifiedAt: PropTypes.string,
  associationsFrom: PropTypes.arrayOf(AssociationShape),
  associationsTo: PropTypes.arrayOf(AssociationShape),
});

export const DocumentShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  items: PropTypes.arrayOf(DocumentItemShape),
});
